import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {Modal} from "reactstrap";
import LineChart from "../../../common/charts/LineChart";
import SimpleTable from "../../../common/tables/SimpleTable";
import {getRusDateHourString} from "../../../../utils/dateUtils";
import ModalBody from "reactstrap/es/ModalBody";

export const RosLineModal = forwardRef((props, ref) => {

    const {rosLineData} = props;
    const [isOpened, setIsOpened] = useState(false);
    const [chartData, setChartData] = useState({labels: [], chartData: []});
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (!isOpened || !rosLineData ||  rosLineData.line?.length === 0) {
            setChartData({labels: [], chartData: []});
            return;
        }
        const chartData = {labels: rosLineData.line.map((item, idx) => (idx + 1 + "")), chartData: [{lineName: "RoS", lineData: rosLineData.line}]};
        setChartData(chartData);
        const tableData = rosLineData.line.map((item, idx) => {return {day: (idx + 1), ros: item}});
        setTableData(tableData);
    }, [rosLineData, isOpened]);

    useImperativeHandle(ref, () => ({
        openModal() {
            setIsOpened(true);
        }

    }));

    const toggle = () => {
        setIsOpened(!isOpened);
    };

    const tableColumns = () => {
        const columns = [
            {
                name: "День",
                key: "day",
                getBodyCellValue: item => item.day,
                headerCellStyle: {textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "RoS",
                key: "ros",
                getBodyCellValue: item => item.ros,
                headerCellStyle: {textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
        ];
        return columns;
    };

    return (
        <Modal className="ros-line-modal" isOpen={isOpened} toggle={() => toggle()}>
            <ModalBody>
            <div style={{padding: "10px", fontSize: "14px", textAlign: "center"}}>
                <RosLineEditPopoverLabelItem name={"Line ID"} value={rosLineData?.lineId}/>
                <RosLineEditPopoverLabelItem name={"Название"} value={rosLineData?.name}/>
                <RosLineEditPopoverLabelItem name={"Дата добавления"} value={rosLineData?.createdAt ? getRusDateHourString(new Date(rosLineData.createdAt)) : ''}/>
            </div>

            <div style={{padding: "5px", width: ((window.innerWidth * 0.95) + "px")}}>

                <div className="row" >
                    <div className="col-8 col-lg-10" style={{height: ((window.innerHeight * 0.85) + "px")}}>
                        <LineChart labels={chartData?.labels} displayedLines={["RoS"]} chartData={chartData?.chartData}/>
                    </div>
                    <div className="col-4 col-lg-2" style={{overflowY : "auto", maxHeight: ((window.innerHeight * 0.85) + "px")}}>
                        <SimpleTable tableClassName="table table-bordered nowrap sticky-header sticky-action statistic_table userselecttext"
                                     columns={tableColumns()} data={tableData} bodyRowKey="day"/>
                    </div>
                </div>
            </div>
            </ModalBody>
        </Modal>
    )
});

const RosLineEditPopoverLabelItem = ({name, value}) => {
    return <span style={{padding: "10px"}}><b style={{opacity: "0.8"}}>{name}:</b> {value}</span>
};